import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/copy';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="w-full border-y border-sand bg-white" data-id="element-60" data-mp="1lc1yr8r0kvp2">
      <div className="mx-auto w-full max-w-3xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-61" data-mp="1ge8uil99ubrf">
        <h2 id="faq" className="font-display text-[1.6rem] font-bold leading-tight text-ink sm:text-3xl lg:text-[2.5rem]" data-id="element-62" data-mp="2dz4vpwg1kyd7">
          Preguntas frecuentes
        </h2>

        <div className="mt-6 divide-y divide-sand border-y border-sand sm:mt-10" data-id="element-63" data-mp="2418imz3jntcg">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-64" data-mp="so64eaox3fvg" data-mpi={index}>
                <h3 data-id="element-65" data-mp="sl0h90zumo2d">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 py-4 text-left outline-none transition-colors duration-150 ease-smooth hover:text-navy focus-visible:ring-2 focus-visible:ring-gold/60 sm:gap-6 sm:py-5" data-id="element-66" data-mp="no0aenv6dha7">
                    <span className="text-[1rem] font-semibold text-ink sm:text-lg" data-id="element-67" data-mp="kko3bfz7whug">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-68" data-mp="bj8484dus25j" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-69" data-mp="3jyrt6r7hqyes">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-70" data-mp="3nya5iyl8y160">
                      <p className="pb-5 pr-2 text-[0.95rem] leading-relaxed text-muted sm:pb-6 sm:pr-10 sm:text-base" data-id="element-71" data-mp="1ftjd1zzu11t3">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}